import { lazy } from 'react';
import { Loadable } from './Loadable';
import { PATH_DASHBOARD } from './paths';

const perfilRoutes = [
  {
    component: Loadable(lazy(() => import('../pages/perfil/Perfil'))),
    path: PATH_DASHBOARD.perfil.path,
    shouldRender: PATH_DASHBOARD.perfil.renderCondition,
  },
];

export default perfilRoutes;
